import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { catchError, filter, Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalTermsAndConditionsComponent } from '../../modal-terms-and-conditions/modal-terms-and-conditions.component';
import { LocalStorageService } from '../services/local-storage.service';


@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = '';

    this.authService.token$.pipe(
      filter(authToken => !!authToken)
    ).subscribe(authToken => {
      token = authToken;
    });

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`, 
    });
    req = req.clone({headers});
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        // TOC errors
        if (err.status === 401 && err.error.error.includes('toc_')) {
          let error = err.error.error;
          switch (error) {
            case 'toc_signature_invalid':
              this._snackBar.open(`Our servers have reason to believe you tried to accept the terms and conditions on behalf of someone else. If this is not the case, please contact support.`, 'OK', {duration: 5000}); break;
            case 'toc_signature_expired':
              this._snackBar.open(`The timeframe to accept the terms and conditions has expired. Please retry.`, 'OK', {duration: 2000}); break;
          }
          throw err;
        }
        
        // Verification error
        if (err.status === 401 && !err.error.error.includes('verification')) {
          this.authService.clearToken();
        }

        // // Terms and conditions error
        // if (err.status === 403) {
        //   let error = err.error.error;
        //   switch (error) {
        //     case 'toc_never':
        //       break;
        //     case 'toc_expired':
        //       this._snackBar.open(`Please accept our updated terms and conditions.`, 'OK', {duration: 2000}); 
        //       break;
        //   }

        //   // Route user to the terms and conditions page
        //   this.dialog.open(ModalTermsAndConditionsComponent, {
        //     data: {
        //       signature: err.error.signature,
        //       username: req.body.username,
        //       password: req.body.password
        //     }
        //   });
        //   throw err;
        // }

        // Rate limit error
        if (err.status === 429) {
          this._snackBar.open('Too many requests. Please wait a few seconds before retrying.', 'OK', {duration: 5000});
          throw err;
        }


        // Error-style error
        if (!!err?.error) {
          if (!!err.error.content) {
            if (err.error.content.startsWith('Error:')) {
              throw err;
            }
            this._snackBar.open(`${err.error?.content}`, 'OK', {duration: 5000});
          }
          else if (!!err.error.error) {
            let shortError, longError, initialInput, validInput;
            let duration = 5000;
            shortError = err.error.error + ':';
            
            if (!!err.error.error_message) {
              longError = `${err.error.error_message}`;
              if (longError.includes('session') && longError.includes('expired')) {
                let tokenAcquisitionString = this.localStorageService.getItem('sequenza_token_acquired_at');

                // Check if the token acquisition time is older than 24 hours
                // If so, set the duration to 2000ms (2 seconds)
                try {
                  const tokenAcquisitionMoment = new Date(JSON.parse(tokenAcquisitionString));
                  if (tokenAcquisitionMoment < new Date(Date.now() - 1000 * 60 * 60 * 24)) {throw err;} else {longError = `Please log in again.`;}
                } catch (e) {if (e instanceof HttpErrorResponse) {throw err;} else {console.error('Error parsing token acquisition moment:', e);}}
                duration = 2000;
              }
            } else { longError = ''; }

            if (!!err.error.initial_input) {
              initialInput = ` (initial input: ${err.error.initial_input})`;
            } else { initialInput = ''; }

            if (!!err.error.valid_input) {
              validInput = ` (valid input: ${err.error.valid_input})`;
            } else { validInput = ''; }
            
            const errorTexts = {
              shortError: shortError,
              longError: longError,
              initialInput: initialInput,
              validInput: validInput
             };
            this.report(errorTexts, 'OK', duration);
        } else { 
          this._snackBar.open('An error occurred. Please try again.', 'OK', {duration: 5000});
        }     
      }
      throw err;
  }));
  }

  report(errorTexts, confirmText, duration = 5000) {
    // Check if page contains a loading-message element
    const loadingMessageElement = document.querySelector('.loading-message');
    if (loadingMessageElement) {
      loadingMessageElement.textContent = `${errorTexts.longError}${errorTexts.initialInput}${errorTexts.validInput}`;
      loadingMessageElement.classList.add('error');
    } else {
      this._snackBar.open(`${errorTexts.shortError}${errorTexts.longError}${errorTexts.initialInput}${errorTexts.validInput}`, confirmText, {duration: duration});
    }
  }
}
